import store from "@/store";

export const vRole = {
  mounted(el, binding) {
    const { value } = binding

    if (!value) return

    let hasPermission = false

    if (typeof value === 'string') {
      hasPermission = store.getters.hasRole(value)
    } else if (Array.isArray(value)) {
      hasPermission = store.getters.hasAnyRoles(value)
    }

    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  }
}